import { render, staticRenderFns } from "./AdvUpload.vue?vue&type=template&id=036f41ce&scoped=true&"
import script from "./AdvUpload.vue?vue&type=script&lang=js&"
export * from "./AdvUpload.vue?vue&type=script&lang=js&"
import style0 from "./AdvUpload.vue?vue&type=style&index=0&id=036f41ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f41ce",
  null
  
)

export default component.exports